import { useEffect, useState } from 'react';
import { WishlistEvents } from '../enums/wishlistEvents';
import { getAnonymousWishlist } from '../helper/getAnonymousWishlist';
var useWishlistSubscribe = function (initialWishlist) {
    var _a = useState(initialWishlist), wishlist = _a[0], setWishList = _a[1];
    var handleListUpdate = function (event) {
        setWishList(event.detail);
    };
    useEffect(function () {
        if (!initialWishlist) {
            setWishList(getAnonymousWishlist());
        }
        document.addEventListener(WishlistEvents.CHANGE, handleListUpdate);
        return function () {
            document.removeEventListener(WishlistEvents.CHANGE, handleListUpdate);
        };
    }, [initialWishlist]);
    return {
        wishlist: wishlist,
    };
};
export { useWishlistSubscribe };
//# sourceMappingURL=useWishlistSubscribe.js.map